<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-navigation-drawer :mini-variant.sync="mini" app v-model="drawer" :permanent="$vuetify.breakpoint.mdAndUp">
            <span v-if="mini">
              <v-list-item style="height: 92px">
                <img src="../../assets/gfi-small.png" class="small-logo"/>
              </v-list-item>
            </span>

            <span v-if="!mini">
              <v-list-item style="height: 92px">
                <img src="../../assets/gfi-small.png" class="logoStyle" alt="logo"/>
              </v-list-item>
            </span>

      <v-divider></v-divider>
      <v-list nav dense>
        <v-list-item-group color="primary">
          <router-link to="/dashboard">
            <v-list-item>
              <v-list-item-icon>
                <v-icon small>mdi-chart-areaspline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Dashboard</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link :to="`/${product.toUpperCase()}`"
                       v-for="(product, idx) in $store.state.home.user.products" :key="idx">
            <v-list-item>
              <v-list-item-icon>
                <v-icon v-if="multiCategory" small>{{ $t(`icon.${product.toUpperCase()}`) }}</v-icon>
                <v-icon v-else small>mdi-account-tie</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-if="multiCategory">{{ product }}</v-list-item-title>
                <v-list-item-title v-else>Results</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <!--<router-link to="/learningResources">
              <v-list-item>
                  <v-list-item-icon>
                      <v-icon small>mdi-file-download</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                      <v-list-item-title>Learning Resources</v-list-item-title>
                  </v-list-item-content>
              </v-list-item>
          </router-link>-->
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script>
import {EventBus} from '../../_helpers'
import {preLoginService} from "../../services"

export default {
  name: 'SideBar',
  data() {
    return {
      drawer: false,
      mini: true,
      fav: true,
      menu: false,
      item: '',
      message: false,
      hints: true,
      smallImage: true,
      productLogo: ''
    }
  },
  methods: {
    handleSideBar: function () {
      this.mini = !this.mini
      this.drawer = !this.drawer
    },
    handleSideBarMobile: function () {
      this.drawer = true
      this.mini = false
    },
    handleSideBarTab: function () {
      this.mini = !this.mini
      this.drawer = !this.drawer
    },
    logoData: function () {
      preLoginService.getLogoData(window.location.host).then(response => {
        this.productLogo = response.dataResponse.productLogo
      }).catch(error => {
        console.log(error)
      })
    },
    getProductLogoImageUrl: function () {
      return process.env.VUE_APP_BACKEND_URL + '/api/media/logo/' + this.productLogo
    }
  },
  computed: {
    isUserAuthenticated() {
      return this.$store.state.home.authenticated
    },
    multiCategory() {
      return this.$store.state.home.user.products.length > 1
    }
  },
  created() {
    EventBus.$on('Clicked', this.handleSideBar)
    EventBus.$on('Sidebar', this.handleSideBarMobile)
    EventBus.$on('SidebarForTab', this.handleSideBarTab)
    this.logoData()
  }
}
</script>
<style>
.v-application a {
  text-decoration: none;
}

.small-logo {
  width: 100%;
  height: auto
}

@media only screen and (min-width: 1301px) {
  .logoStyle {
    width: 70%;
    height: auto;
    margin: 0 0 0 25px;
  }
}

@media only screen and (min-width: 1000px) and (max-width: 1300px) {
  .logoStyle {
    width: 50%;
    height: auto;
    margin: 0 0 0 23%;
  }
}

@media only screen and (max-width: 999px) {
  .logoStyle {
    width: 40%;
    height: auto;
    margin: 0 0 0 25%;
  }
}
</style>
